import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBleCqlGtadeliXcwjvo6o3LTfODhwukhM",
  authDomain: "tropic-innovation.firebaseapp.com",
  projectId: "tropic-innovation",
  storageBucket: "tropic-innovation.firebasestorage.app",
  messagingSenderId: "426780980231",
  appId: "1:426780980231:web:94a840c932866afcd1a6a2",
  measurementId: "G-VCCBKW912X"
};

// Initialize Firebase and services
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Function for Google sign-in
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    throw error;
  }
};
